
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { ShieldCheck, Zap, Layers, Globe } from 'lucide-react';

const RadexFeatures = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: ShieldCheck,
      title: t('radex.features.security') || "Client Protection",
      description: t('radex.features.securityText') || "Robust security protocols to safeguard client funds and personal data, ensuring a safe trading environment."
    },
    {
      icon: Zap,
      title: t('radex.features.technology') || "Cutting-Edge Platform",
      description: t('radex.features.technologyText') || "Advanced trading technology with reliable execution and professional tools for traders of all levels."
    },
    {
      icon: Layers,
      title: t('radex.features.transparency') || "Full Transparency",
      description: t('radex.features.transparencyText') || "Clear, honest communication and dependable trade execution, maintaining the highest standards of transparency."
    },
    {
      icon: Globe,
      title: t('radex.features.global') || "Global Access",
      description: t('radex.features.globalText') || "Multilingual support and services catering to traders from various regions and backgrounds."
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background image with overlay - Swapped with RadexPartnership.tsx background */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 to-gray-800 z-0"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            {t('radex.features.title') || "Why did we choose Radex Markets?"}
          </h2>
          <p className="text-lg text-gray-300">
            {t('radex.features.subtitle') || "Experience the advantages of trading with a broker committed to excellence"}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="bg-gray-800/60 backdrop-blur-sm border border-gray-700 rounded-xl p-6 transition-all hover:transform hover:-translate-y-1 hover:shadow-xl hover:shadow-purple-900/20"
              >
                <div className="bg-purple-500/10 p-3 rounded-lg inline-flex mb-6">
                  <Icon className="h-7 w-7 text-purple-400" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RadexFeatures;
